import LockRoundedIcon from '@mui/icons-material/LockRounded'
import { Stack, Typography } from '@mui/material'
import type { ReactNode } from 'react'

import { useAuth } from '@/features/auth/hooks/useAuth'

/**
 * SA-3 (Sección 3) — gate de acceso a /super-admin/*. Esto es UX, NUNCA
 * la autoridad real: cada request a /api/v1/super-admin/* sigue siendo
 * validada de forma independiente por `require_platform_operator` en el
 * backend (SA-1), incluso si alguien manipulara este componente o
 * escribiera la URL directamente en el navegador. Ocultar la ruta aquí
 * solo evita renderizar el shell a quien no debería verlo — no es una
 * capa de seguridad por sí sola.
 */
export function PlatformOperatorRoute({ children }: { children: ReactNode }) {
  const { user } = useAuth()

  if (!user?.is_platform_operator) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={2}
        sx={{ minHeight: '100vh', textAlign: 'center', bgcolor: '#0B0D12', color: '#E5E7EB' }}
      >
        <LockRoundedIcon sx={{ fontSize: 44, color: 'text.disabled' }} />
        <Typography variant="h6">No tienes autorización para acceder a la administración de plataforma.</Typography>
      </Stack>
    )
  }

  return children
}
